import { render } from "./WelcomeComponent.vue?vue&type=template&id=4f9bf27a"
import script from "./WelcomeComponent.js?vue&type=script&lang=js"
export * from "./WelcomeComponent.js?vue&type=script&lang=js"

import "./WelcomeComponent.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\Program Files\\Ampps\\www\\adapter\\metahumen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__